import React, { useState, useEffect } from 'react'
import { requestWebmapConfig } from 'api/config'
import { showErrorToast } from 'utils/toast'

export const ConfigContext = React.createContext({
  // default context values for testing and intelliSense
  SHAPEFILE_GENERATE_URL: 'SHAPEFILE_GENERATE_URL',
  FRONT_MAP_KBA_LAYER_URL: 'FRONT_MAP_KBA_LAYER_URL',
  KBA_FEATURE_LAYER_URL: 'KBA_FEATURE_LAYER_URL',
  ESRI_API_KEY: 'ESRI_API_KEY'
})

export const WebmapConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null)

  const showFetchConfigError = (error) => {
    showErrorToast('Failed to fetch map configuration. See console for details.')
    console.error('Failed to fetch map configuration:', error)
  }

  useEffect(() => {
    requestWebmapConfig()
      .then((data) => {
        if (data.error) {
          showFetchConfigError(data.error)
        } else {
          setConfig(data)
        }
      })
      .catch(showFetchConfigError)
  }, [])

  if (!config) {
    return null
  }

  return (
    <ConfigContext.Provider
      value={config}
    >
      {children}
    </ConfigContext.Provider>
  )
}

export default WebmapConfigProvider
